import gql from 'graphql-tag';

const checkCurrentEnrollmentOfDealerQuery = gql`
  query checkCurrentEnrollmentOfDealerQuery($dealerNumber: String!) {
    checkCurrentEnrollmentOfDealer(dealerNumber: $dealerNumber) {
      description
    }
  }
`;

export default checkCurrentEnrollmentOfDealerQuery;
